import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// utils
import {loadIfStateAvailableInSessionStorage, savePageStateInSessionStorage, Translations} from '../../../../../../utils';
// restClient
import {eapiClient, taxonomyHostClient} from '../../../../../../restClient';
// children
import MultiLineSelect from '../../../../../common/MultiLineSelect';
import PersistLink from '../../../../../common/PersistLink';
//action Creator
import { setBasicDetailAcc } from '../../actions/actionCreator';

class AddStandalone extends Component{
  constructor(props){
    super(props);
    this.state={
      noOfAccount:1,
      selectedAccounts:[] ,
      filterPreviousList: [],
      currentStandalone:[]
    }
    this.mode  =  this.props.location.state.mode;
    this.payload = new addPoolPayload(this.mode);
    this.apiURL = `/product/gls/${this.props.notionalPoolingdata.id}`;
    this.taxanomyURL='/product/taxonomies/notionPoolingCountries';
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }


  handleStandaloneAccountEditClick = (detail) =>{
    var {productId} = this.props.match.params;
    ///case-body/create-new-other-account-ie/:productId/:otherAccountId
    if(detail) {
      savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
      this.props.history.push("/case-body/create-new-other-account-np/" + productId + "/" + detail);
    }
  }

  loadState = () => {
    if(this.mode === 'edit'){
      this.setState({
        noOfAccount : this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount.length || 1,
        selectedAccounts :this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount
      });
    } else {
      this.setState({
        noOfAccount: 1,
        selectedAccounts: []
      })
    }
  }

  componentWillMount(){

    if(this.mode === 'edit'){
      this.setState({
        noOfAccount : this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount.length || 1,
        selectedAccounts :this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount,
        standAloneAccounts : this.props.standAloneAccounts
      });
    } else {
      this.setState({
        noOfAccount: 1,
        selectedAccounts: [],
        standAloneAccounts : this.props.standAloneAccounts
      })
    }
    
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadState()
    });
  }

  componentWillReceiveProps(nextProps){
    if( this.props.lang.currentLang.lang!== nextProps.lang.currentLang.lang){
      this.getTaxanomyUrl();
      this.getAccountPoolTaxanomy();
    }
  }

  getAccountPoolTaxanomy = () => {    
    let standAloneAccounts = this.state.standAloneAccounts;
    taxonomyHostClient(this.translations(this.props.pageJson1.countryTaxonomy))
      .then(({ data }) => {
        let currentListCountries = data.responseData.classificationNodes;
        if (standAloneAccounts !== undefined) {
          standAloneAccounts = standAloneAccounts.map(item => {
            currentListCountries.filter(countItem => {
              if ('country' in item) {
                if (countItem.id === item.country.value) {
                  item.country.name = countItem.name
                }
              }
              return countItem;
            });
            this.setState({...standAloneAccounts})
          });
        }
      });
  }

  getTaxanomyUrl =() =>{
   return this.taxanomyURL = this.translations(this.props.pageJson1.notionalPoolingTaxonomy)
  }

  componentDidMount() {
    let {caseId, productId} = this.props.match.params;
    let prevStandAloneAccounts = this.props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount
    eapiClient(`/product/gls/${productId}/case/${caseId}/account/`,{  method:'GET'})
    .then(({data}) => {
      this.props.setBasicDetailAcc(data.responseData);

        let accountListFilter =[];
        let countryId = this.props.notionalPoolingdata.location.value.split(':').reverse()[1];
        this.props.standAloneAccounts.filter((account, index) =>{
          if (countryId !== undefined && countryId === account.country.value.split(':').reverse()[1]) {
            accountListFilter.push(account);
          }
        })

        this.setState({
            ...this.state,
            standAloneAccounts : accountListFilter
        },()=>{
          let getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
          let getCurrentDropDownValue = window.sessionStorage.getItem('key'+ getCurrentDropDown);
          let CurrentDropDownValueParsed =  JSON.parse(getCurrentDropDownValue);
          if(getCurrentDropDown !== null){
            var getCurrentDropDownName =  getCurrentDropDown.substring(0,getCurrentDropDown.length -1);
          }
          if(getCurrentDropDownName ==='standAloneAccounts'){
            var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length -1);
          }

          let accountDetail = [...this.state.selectedAccounts]
          if(getCurrentDropDownName === 'standAloneAccounts' &&  getCurrentDropDownValue !== null){
            accountDetail[getCurrentDropDownIndex] = CurrentDropDownValueParsed.id;
            let localObject = {target : {name:'multiAccount', value : accountDetail}}
            this.setState({
              selectedAccounts: accountDetail,
              filterPreviousList: prevStandAloneAccounts
            },()=>{})
            this._getDataMakePayload(localObject)
          }else {
            this.setState({
              filterPreviousList: prevStandAloneAccounts
            },()=>{})
          }
          window.sessionStorage.removeItem("getCurrentDropDown");
          window.sessionStorage.removeItem('key'+ getCurrentDropDown);
          this.getTaxanomyUrl();
          this.getAccountPoolTaxanomy();
        })
    });

    // if(getCurrentDropDownName === 'standAloneAccounts' &&  getCurrentDropDownValue !== null){
    //   _standAloneAccounts[getCurrentDropDownIndex] = {id: getCurrentDropDownValue};
    //   this.setState({
    //     currentStandalone: {
    //       ...this.state.currentStandalone,
    //       currentStandalone : _standAloneAccounts
    //     }
    //   });
    // }
  }

  _getDataMakePayload =(event) =>{
    this.payload.setPaylod(event, this.props);
  }

  isEmpty =(obj) => {
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
      return false;
    }
    return true;
  }

  filterVal = (current,prev) => {
    for(var i=0;i<current.length; i++){
      let flag = 0;

      for(var j = 0;j<prev.length; j++){
        if(current[i] === prev[j]){
          flag = 1
        }
      }
      if(flag === 0){
        prev.push(current[i])
      }
    }
    return prev
  }

  onFormSubmit = (event) => {
    let pools = this.props.notionalPoolingdata;
    let accountDetails1 = this.state.selectedAccounts;
    let setFinalAccounts = this.filterVal(accountDetails1,this.state.filterPreviousList)
    let combineData = setFinalAccounts

    let localObject = {
      target : {
        name:'standAloneAccount',
        value :combineData
      }}
      this._getDataMakePayload(localObject);
      let payloadData = this.payload.getPayload();

      if(payloadData !== 'undefined' && payloadData !== null && !this.isEmpty(payloadData)){
        let requestData = {
          notionalPooling :{
            poolingStructure : payloadData
          },
          id : pools.id,
          lid : pools.lid
        };

        eapiClient(this.apiURL, {
          method: "PUT",
          data: JSON.stringify(requestData)
        })
        .then(({data}) => {
          this.props.history.goBack();
        });
      }else{
        this.props.history.goBack();
      }

    }

    deleteStandAloneAccount = (index) => {
      let accountDetails = [...this.state.selectedAccounts];
      accountDetails.splice(index,1);
      this.setState(prevState =>({
        selectedAccounts: accountDetails,
        noOfAccount: prevState.noOfAccount - 1
      }));

      let localObject = {
        target : {
          name:'standAloneAccount',
          value :accountDetails
        }
      }
      this._getDataMakePayload(localObject);
    }

    handleAccountChange = (index,account) => {
      let accountDetail = [...this.state.selectedAccounts]
      accountDetail[index] = account.id;
      let localObject = {target : {name:'multiAccount', value : accountDetail}}
      this.setState({
        selectedAccounts: accountDetail
      })
      this._getDataMakePayload(localObject);
      //this.props.passAccountDetailsToAdvantage(accountDetail);
    }


    addAccounts = () => {
      let _currentAccounts = [...this.state.selectedAccounts]
      this.setState( prevState => ({
        noOfAccount: prevState.noOfAccount + 1,
        selectedAccounts: _currentAccounts
      }))
    }

    saveState = () => {
      savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
    }

    renderStandAloneAccount = () => {
      let standAloneAccountjsx =[];
      const {pageJson1} = this.props;
      for(var i = 0; i<=this.state.noOfAccount-1; i++) {
        standAloneAccountjsx.push(
          <div className="gdocs-stand-alone-form" key={i}>
          <div className="gdocs-stand-alone-wrapper">
          <div className="gdocs-stand-alone-position">{this.translations(pageJson1.accounts)} {i+1}</div>
          <div className="gdocs-stand-alone-position">
          {
            (i > 0)
            ? <span className="delete-btn" role="button">
            <i
            className="icon icon-bin"
            onClick={this.deleteStandAloneAccount.bind(this,i)}
            ></i>
            </span>
            : ''
          }

          <MultiLineSelect
          defaultValue="Please select"
          requiredFields={{
            "row1": ["accountType","accountNumber","branchCode","currency","country"],
            "row2": ["accountHolder"],
            "row3": ["bankName", "hsbcBankName","accountTitle"]
          }}

          data={typeof this.state.standAloneAccounts !== 'undefined' ? this.state.standAloneAccounts: []}
          value= {this.state.selectedAccounts.length > 0 && this.state.selectedAccounts[i] !== undefined ? this.state.selectedAccounts[i] : ''}
          multiAccount={true}
          disabledOptions = {this.state.selectedAccounts}
          onEdit={this.handleStandaloneAccountEditClick.bind(this,this.state.selectedAccounts[i])}
          _onChange={this.handleAccountChange.bind(this, i)}
          />

          <PersistLink
          history={this.props.history}
          state={this.state}
          className="mrg-left"
          to={`/case-body/create-new-other-account-np/${this.props.match.params.productId}`}
          data={`standAloneAccounts${i}`}>
          + {this.translations(pageJson1.addOtherAccount)}
          </PersistLink>
          </div>
          </div>
          </div>);
        }
        return standAloneAccountjsx;
      }

      render(){
        const {pageJson1} = this.props;
        return (
          <div className="add-standalone-wrapper">
          <div className="add-standalone-container add-standalone-containerh">
          <div className="pannel-heading-container">
          <h2 className="pannel-heading">{this.translations(pageJson1.addStandaloneAccBtnText)}</h2>
          <p className="optional-text"><b>{this.translations(pageJson1.descriptionText)}</b></p>
          </div>
          <div className="gdocs-clear-float"></div>
          <div>{this.renderStandAloneAccount()}</div>
          <div className="gdocs-clear-float"></div>
          <div>
          <button
          className="gdocs-btn-default marg-bottom"
          onClick={this.addAccounts}
          >
          <i className="icon icon-add"></i>
          {this.translations(pageJson1.paymentAuthoriser)}
          </button>
          </div>
          <div className="save-btn-right">
          <button onClick={this.onFormSubmit} className='btn save-btn'>{this.translations(pageJson1.addStandaloneAccBtnText)}</button>
          </div>
          </div>
          </div>
        );
      }

    }

    class addPoolPayload {
      constructor(mode){
        this.data = {};
        this.mode = mode;
      }
      setPaylod(event , props){
        switch (event.target.name) {
          case "standAloneAccount":
          this.data.standAloneAccount = event.target.value
          break;
        }
      }
      getPayload(){
        return this.data;
      }
    }
    const mapStateToProps =  (state, props)  => {
      let _standAloneAccounts =[];
      if(state.currentProductNotionalPooling.data.notionalPooling.poolingStructure.standAloneAccount !== undefined){
        _standAloneAccounts = state.currentProductNotionalPooling.accounts.filter(item => !state.currentProductNotionalPooling.data.notionalPooling.poolingStructure.standAloneAccount.includes(item.id))
      }else {
        _standAloneAccounts =  state.currentProductNotionalPooling.accounts
      }
      return {
        notionalPoolingdata : state.currentProductNotionalPooling.data,
        statuses  : state.currentProductNotionalPooling.statuses,
        currency : state.currentProductNotionalPooling.currency,
        standAloneAccounts : _standAloneAccounts,
        cases : state.cases,
        pageJson1 : state.currentProductNotionalPooling.pageJson1,
        lang: state.lang
      }
    }
    const mapDispatchToProps = dispatch =>{
      return {
        setBasicDetailAcc : accounts => {
          dispatch(setBasicDetailAcc(accounts))
        }
      }
    };
    export default connect(mapStateToProps, mapDispatchToProps)(AddStandalone);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/GlsNotionalPoolingStrucutre/AddStandalone/index.js